import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api, errText } from "../../lib/api";

const BADGE = { approved: "bg-green-50 text-green-700", rejected: "bg-red-50 text-red-700" };
const badge = (s) => BADGE[s] || "bg-amber-50 text-amber-700";

export default function AdminLeave() {
  const [tab, setTab] = useState("pending");
  const [list, setList] = useState([]);
  const [policies, setPolicies] = useState([]);

  const load = useCallback(() => api.get("/leave/requests", { params: tab === "pending" ? { status: "pending" } : {} }).then((r) => setList(r.data)), [tab]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { api.get("/leave/policies").then((r) => setPolicies(r.data)); }, []);

  const review = async (id, status) => {
    try {
      await api.put(`/leave/requests/${id}`, { status });
      toast.success(`Leave ${status}`);
      load();
    } catch (e) { toast.error(errText(e)); }
  };

  return (
    <div className="space-y-6" data-testid="admin-leave-page">
      <h1 className="font-heading text-3xl font-extrabold tracking-tight">Leave management</h1>

      <div className="flex gap-2 flex-wrap">
        {[["pending", "Pending approvals"], ["all", "All requests"], ["policies", "Policies"]].map(([k, label]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`leave-tab-${k}`}
            className={`px-5 py-2.5 rounded-full text-sm font-bold transition-colors duration-200 ${tab === k ? "bg-secondary text-white" : "bg-white border border-stone-200 text-stone-600 hover:bg-stone-50"}`}>{label}</button>
        ))}
      </div>

      {tab === "policies" ? (
        <div className="bg-white border border-stone-200 rounded-lg divide-y divide-stone-100 max-w-lg">
          {policies.map((p) => (
            <div key={p.leave_type} className="p-5 flex justify-between items-center">
              <div>
                <div className="font-semibold text-sm">{p.name}</div>
                <div className="text-xs text-stone-500">Code: {p.leave_type}</div>
              </div>
              <div className="font-heading font-extrabold text-lg tabular-nums">{p.annual_quota} <span className="text-xs font-normal text-stone-500">days/yr</span></div>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-white border border-stone-200 rounded-lg divide-y divide-stone-100">
          {list.length === 0 && <p className="p-10 text-center text-stone-400">No leave requests here.</p>}
          {list.map((r) => (
            <div key={r.id} className="p-5 flex flex-wrap items-center justify-between gap-3" data-testid={`leave-request-${r.id}`}>
              <div>
                <div className="font-semibold text-sm">{r.employee_name} <span className="text-xs font-bold text-primary ml-1">{r.leave_type}</span></div>
                <div className="text-xs text-stone-500">{r.from_date} → {r.to_date} · {r.days} day{r.days > 1 ? "s" : ""} · {r.reason}</div>
              </div>
              {r.status === "pending" ? (
                <div className="flex gap-2">
                  <button onClick={() => review(r.id, "approved")} data-testid={`approve-leave-${r.id}`} className="tap-scale px-5 py-2.5 rounded-full bg-green-700 text-white text-sm font-bold hover:bg-green-800 transition-colors duration-200">Approve</button>
                  <button onClick={() => review(r.id, "rejected")} data-testid={`reject-leave-${r.id}`} className="tap-scale px-5 py-2.5 rounded-full bg-white border border-stone-300 text-sm font-bold text-stone-700 hover:bg-stone-50 transition-colors duration-200">Reject</button>
                </div>
              ) : <span className={`text-xs font-bold px-3 py-1.5 rounded-full ${badge(r.status)}`}>{r.status}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
